function Map(_props) {
  return null;
}
export {
  Map
};
//# sourceMappingURL=Map.js.map
